import styled from 'styled-components';

import { Container } from '../../../../common/Styles';

export const MyBizBlogList = styled.div(
	({ theme: { down, breakpoints } }) => `

		.slick-track {
			display: flex;
		}

		>div >div{
		&.slick-dots ul li{
			margin: 0;
		} 
		&.slick-dots li {
			position: relative;
			display: inline-block;
			width: 20px;
			height: 20px;
			margin: 0 5px;
			padding: 0;
			cursor: pointer;
			}
		}

		>div >div >div >div{
			&.slick-active{
				&:last-child{
					margin-right: 0;
				}
			}
		}

		${down(breakpoints.md)} {
			margin-top: 28px;
			padding-left: 16px;
		}
	
	`
);

export const MyBizBlogItem = styled.div(
	({ theme: { down, breakpoints } }) => `

	background: #EDEDED;
	border-radius: 2px;
	padding: 24px 24px 16px;
	width: 96% !important;
	margin-bottom: 16px;
	cursor: pointer;
	min-height: 300px;
	&:hover{
		background: #ffffff;
		box-shadow: 0px 2px 40px rgba(0, 0, 0, 0.16);
		p{
			&:last-child{
				color: #000000;
			}   
		}
	}
	${down(breakpoints.md)} {
		background: #ffffff;
		margin-bottom: 0;
	}
	`
);

export const ArrowNextButton = styled.span`
	position: absolute;
	bottom: -33px;
	top: auto;
	right: 23px;
	z-index: 6;
	color: #0091ff;
	font-size: 16px;
	font-weight: 900;
	font-family: "Lato";
	cursor: pointer;
	&.slick-disabled {
		color: #e0e0e0;
			opacity: 1;
	}
	`;

export const ArrowPrevButton = styled.span`
	position: absolute;
	bottom: -33px;
	top: auto;
	left: 82%;
	color: #0091ff;
	font-size: 16px;
	font-weight: 900;
	font-family: "Lato";
	cursor: pointer;
	&.slick-disabled {
		color: #e0e0e0;
			opacity: 1;
	}
	`;

export const CustomSlideNumbers = styled.div`
	position: absolute;
	right: 75px;
	bottom: -33px;
	width: auto;
	`;

export const CustomSlideDot = styled.ul`
	margin-right: 50px
	`;

export const Wrapper = styled.div`
	background-color: #f5f5f5;
	`;

export const BizContainer = styled(Container)`
	padding-top: 50px;
	padding-bottom: 50px;
	`;
